import { Pipe, PipeTransform } from '@angular/core';
import { Instrument } from 'src/app/legacy/price-and-valuation/state/instrument.model';
import { TranslateEnumPipe } from '.';

@Pipe({
    name: 'decorate'
})
export class DecoratePipe implements PipeTransform {
    constructor(private pipe: TranslateEnumPipe) {}

    transform(instrument: Instrument): unknown {
        if (instrument.name) return instrument.name;

        if (instrument.type === 'CASH')
            return this.pipe.transform(instrument.decoratedInstrumentName);

        return `${instrument.decoratedInstrumentName} (${[
            this.pipe.transform(instrument.type),
            instrument.currency
        ].join(', ')})`;
    }
}
